import { render, staticRenderFns } from "./SurveyTable.vue?vue&type=template&id=1ac87fcf&scoped=true"
import script from "./SurveyTable.vue?vue&type=script&lang=js"
export * from "./SurveyTable.vue?vue&type=script&lang=js"
import style0 from "./SurveyTable.vue?vue&type=style&index=0&id=1ac87fcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac87fcf",
  null
  
)

export default component.exports